export const getQueryStringParameter = (parameterName) => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const value = params.get(parameterName);

    return value;
}